<div class="cx-order-confirmation-message">
  <h4>{{ 'uigCheckout.confirmation.thanks' | cxTranslate }}</h4>
  <p>
    {{ 'uigCheckout.confirmation.text' | cxTranslate }}
    <a
      [routerLink]="{ cxRoute: 'orders' } | cxUrl"
      class="cx-tc-link"
    >{{ 'uigCheckout.confirmation.link' | cxTranslate }}</a>.
  </p>
</div>
